module.exports = __webpack_public_path__ + "img/alexandre_assinatura-01.0b7cdcff.svg";